import { Component, OnInit } from '@angular/core';
import { RentalService } from '../../services/rental.service';
import { Rental } from '../../models/rental.model';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-apply',
  templateUrl: './apply.component.html',
  styleUrls: ['./apply.component.scss'],
  imports: [CommonModule],
  standalone: true
})
export class ApplyComponent implements OnInit {
  rentals$: Observable<Rental[]> = this.rentalService.getAvailableRentals();

  constructor(private rentalService: RentalService, private router: Router) {}

  ngOnInit() {

  }

  viewDetails(id: string) {
    this.router.navigate(['/rental', id]);
  }
}
